import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Loader } from "../Components/Loader";

import Dashboard from "../Pages/Dashboard";

import CreateProduct from "../Pages/Product/Create";
import EditProduct from "../Pages/Product/Edit";
import ListProduct from "../Pages/Product/List";
import ProductDetails from "../Pages/Product/View/index";

import CreateCategory from "../Pages/Category/Create";
import ListCategory from "../Pages/Category/List";
import CategoryDetails from "../Pages/Category/View/index";

import CreateCompany from "../Pages/CompanyInfo/Create";
import ListCompany from "../Pages/CompanyInfo/List";
import EditCompany from "../Pages/CompanyInfo/Edit";
import CompanyDetail from "../Pages/CompanyInfo/Detail";
import CompanyHistory from "../Pages/CompanyInfo/History";

import CreateDriver from "../Pages/Driver/Create";
import ListDriver from "../Pages/Driver/List";
import DriverHistory from "../Pages/Driver/View";

import ListEmail from "../Pages/Email/List";
import CreateEmail from "../Pages/Email/Create";

import ListNote from "../Pages/Note/List";
import CreateNote from "../Pages/Note/Create";

import DeviceList from "../Pages/Device/List";
import DeviceCreate from "../Pages/Device/Create";
import DeviceEdit from "../Pages/Device/Edit";
import DeviceView from "../Pages/Device/View";

import PlaylistList from "../Pages/Playlist/List";
import PlaylistEdit from "../Pages/Playlist/Edit";
import PosOauthCallback from "../Pages/Playlist/Edit/Pos/PosOauthCallback";

import PlaylistGroupList from "../Pages/PlaylistGroup/List";
import PlaylistGroupCreate from "../Pages/PlaylistGroup/Create";
import PlaylistGroupEdit from "../Pages/PlaylistGroup/Edit";

import MenuScheduleList from "../Pages/MenuSchedule/List";
import MenuScheduleCreate from "../Pages/MenuSchedule/Create";
import MenuScheduleDetail from "../Pages/MenuSchedule/Detail";

import TemplateList from "../Pages/Template/List";
import TemplateEdit from "../Pages/Template/Edit";

import MediaLibrary from "../Pages/Media/Library";

import SignageUsersList from "../Pages/SignageUsers/List";
import SignageActivityList from "../Pages/SignageActivity/List";

import MonitoringDevices from "../Pages/Monitoring/Devices";
import DeviceDetailMonitoring from "../Pages/Monitoring/DeviceDetail";
import BillingReport from "../Pages/Billing/Report";
import AppUpdates from "../Pages/AppUpdates";
import ReleaseDetails from "../Pages/AppUpdates/ReleaseDetails";

import Onboarding from "../Pages/Onboarding/NewClient";
import InstallationGuide from "../Pages/InstallationGuide";
import SystemHealth from "../Pages/System/Health";
import SystemChecklist from "../Pages/System/Checklist";
import SystemLogs from "../Pages/System/Logs";
import SystemBackup from "../Pages/System/Backup";
import PilotChecklist from "../Pages/System/PilotChecklist";
import PilotStatus from "../Pages/Pilot/Status";
import InstallerPage from "../Pages/Installer";
import AndroidDownload from "../Pages/Download/Android";
import PrintSheet from "../Pages/PrintSheet";

import Player from "../Pages/Player";
import PlayerEntry from "../Pages/Player/PlayerEntry";

/**
 * AppRoutes - Digital Signage CMS routes.
 *
 * Device / Playlist / Media routes are added in Phase 2.
 */
const AppRoutes = () => {
  return (
    <Routes>
      <Route
        element={
          <Suspense fallback={<Loader />}>{/* <Fallback /> */}</Suspense>
        }
        path="/fallback"
      />

      <Route
        path="/"
        element={
          <Suspense fallback={<Loader />}>
            <Navigate to="/dashboard" />
          </Suspense>
        }
      />

      <Route
        path="/dashboard"
        element={
          <Suspense fallback={<Loader />}>
            <Dashboard />
          </Suspense>
        }
      />

      {/* Products */}
      <Route
        path="/product/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListProduct />
          </Suspense>
        }
      />
      <Route
        path="/product/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateProduct />
          </Suspense>
        }
      />
      <Route
        path="/product/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            <EditProduct />
          </Suspense>
        }
      />
      <Route
        path="/product-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <ProductDetails />
          </Suspense>
        }
      />

      {/* Categories */}
      <Route
        path="/category/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListCategory />
          </Suspense>
        }
      />
      <Route
        path="/category/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateCategory />
          </Suspense>
        }
      />
      <Route
        path="/category-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <CategoryDetails />
          </Suspense>
        }
      />

      {/* Company */}
      <Route
        path="/company/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateCompany />
          </Suspense>
        }
      />
      <Route
        path="/company/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListCompany />
          </Suspense>
        }
      />
      <Route
        path="/company-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <EditCompany />
          </Suspense>
        }
      />
      <Route
        path="/company/:id"
        element={
          <Suspense fallback={<Loader />}>
            <CompanyDetail />
          </Suspense>
        }
      />
      <Route
        path="/companyInfo-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <CompanyHistory />
          </Suspense>
        }
      />

      {/* Users (Driver module repurposed as Users) */}
      <Route
        path="/team/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateDriver />
          </Suspense>
        }
      />
      <Route
        path="/team/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListDriver />
          </Suspense>
        }
      />
      <Route
        path="/team-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            <DriverHistory />
          </Suspense>
        }
      />

      {/* Settings - templates */}
      <Route
        path="/email/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListEmail />
          </Suspense>
        }
      />
      <Route
        path="/email/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateEmail />
          </Suspense>
        }
      />
      <Route
        path="/note/list"
        element={
          <Suspense fallback={<Loader />}>
            <ListNote />
          </Suspense>
        }
      />
      <Route
        path="/note/create"
        element={
          <Suspense fallback={<Loader />}>
            <CreateNote />
          </Suspense>
        }
      />

      {/* Devices */}
      <Route
        path="/device/list"
        element={
          <Suspense fallback={<Loader />}>
            <DeviceList />
          </Suspense>
        }
      />
      <Route
        path="/device/create"
        element={
          <Suspense fallback={<Loader />}>
            <DeviceCreate />
          </Suspense>
        }
      />
      <Route
        path="/device/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            <DeviceEdit />
          </Suspense>
        }
      />
      <Route
        path="/device/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            <DeviceView />
          </Suspense>
        }
      />

      {/* Playlists */}
      <Route
        path="/playlist/list"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistList />
          </Suspense>
        }
      />
      <Route
        path="/playlist/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistEdit />
          </Suspense>
        }
      />
      {/* Clover OAuth return target (CLOVER_REDIRECT_URI points here). */}
      <Route
        path="/pos/oauth/callback"
        element={
          <Suspense fallback={<Loader />}>
            <PosOauthCallback />
          </Suspense>
        }
      />

      {/* Templates (V2 — layout designer) */}
      <Route
        path="/templates/list"
        element={
          <Suspense fallback={<Loader />}>
            <TemplateList />
          </Suspense>
        }
      />
      <Route
        path="/templates/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            <TemplateEdit />
          </Suspense>
        }
      />

      {/* Playlist Groups */}
      <Route
        path="/playlist-groups/list"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistGroupList />
          </Suspense>
        }
      />
      <Route
        path="/playlist-groups/create"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistGroupCreate />
          </Suspense>
        }
      />
      <Route
        path="/playlist-groups/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            <PlaylistGroupEdit />
          </Suspense>
        }
      />

      {/* Menu Schedules — company-wide "when & how playlists become active".
          Distinct module from Playlist Groups (which manages grouping). */}
      <Route
        path="/menu-schedules/list"
        element={
          <Suspense fallback={<Loader />}>
            <MenuScheduleList />
          </Suspense>
        }
      />
      <Route
        path="/menu-schedules/create"
        element={
          <Suspense fallback={<Loader />}>
            <MenuScheduleCreate />
          </Suspense>
        }
      />
      <Route
        path="/menu-schedules/:id"
        element={
          <Suspense fallback={<Loader />}>
            <MenuScheduleDetail />
          </Suspense>
        }
      />
      <Route
        path="/menu-schedules/:id/edit"
        element={
          <Suspense fallback={<Loader />}>
            <MenuScheduleDetail />
          </Suspense>
        }
      />

      {/* Media Library */}
      <Route
        path="/media/library"
        element={
          <Suspense fallback={<Loader />}>
            <MediaLibrary />
          </Suspense>
        }
      />

      {/* Public Web Player — no admin chrome (LoginProvider + Menu both
          short-circuit on /player...). Loads in a black fullscreen
          canvas; safe to bookmark on signage hardware. */}
      {/* Bare /player — self-service pairing. An unregistered browser
          shows its own pairing code; once an admin claims it the browser
          stores the credential and plays. This is the Windows-PC entry
          point (https://display.cacart.ca/player). */}
      <Route
        path="/player"
        element={
          <Suspense fallback={<Loader />}>
            <PlayerEntry />
          </Suspense>
        }
      />
      {/* Admin-provisioned screens (and Android parity): code in the URL. */}
      <Route
        path="/player/:deviceCode"
        element={
          <Suspense fallback={<Loader />}>
            <Player />
          </Suspense>
        }
      />

      {/* Device Monitoring */}
      <Route
        path="/monitoring/devices"
        element={
          <Suspense fallback={<Loader />}>
            <MonitoringDevices />
          </Suspense>
        }
      />
      {/* Billing */}
      <Route
        path="/billing/devices"
        element={
          <Suspense fallback={<Loader />}>
            <BillingReport />
          </Suspense>
        }
      />
      {/* App Releases */}
      <Route
        path="/app-updates"
        element={
          <Suspense fallback={<Loader />}>
            <AppUpdates />
          </Suspense>
        }
      />
      <Route
        path="/app-updates/:id"
        element={
          <Suspense fallback={<Loader />}>
            <ReleaseDetails />
          </Suspense>
        }
      />
      {/* Onboarding + installation + system utilities (all super-admin) */}
      <Route
        path="/onboarding/new-client"
        element={
          <Suspense fallback={<Loader />}>
            <Onboarding />
          </Suspense>
        }
      />
      <Route
        path="/installation-guide"
        element={
          <Suspense fallback={<Loader />}>
            <InstallationGuide />
          </Suspense>
        }
      />
      <Route
        path="/system/health"
        element={
          <Suspense fallback={<Loader />}>
            <SystemHealth />
          </Suspense>
        }
      />
      <Route
        path="/system/checklist"
        element={
          <Suspense fallback={<Loader />}>
            <SystemChecklist />
          </Suspense>
        }
      />
      <Route
        path="/system/logs"
        element={
          <Suspense fallback={<Loader />}>
            <SystemLogs />
          </Suspense>
        }
      />
      <Route
        path="/system/backup"
        element={
          <Suspense fallback={<Loader />}>
            <SystemBackup />
          </Suspense>
        }
      />
      <Route
        path="/system/pilot-checklist"
        element={
          <Suspense fallback={<Loader />}>
            <PilotChecklist />
          </Suspense>
        }
      />
      <Route
        path="/pilot/status"
        element={
          <Suspense fallback={<Loader />}>
            <PilotStatus />
          </Suspense>
        }
      />
      {/* Public installer page (PIN-protected). Treated as a portal
          route by the chrome short-circuit, so no sidebar / login. */}
      <Route
        path="/installer"
        element={
          <Suspense fallback={<Loader />}>
            <InstallerPage />
          </Suspense>
        }
      />
      <Route
        path="/installer/:pin"
        element={
          <Suspense fallback={<Loader />}>
            <InstallerPage />
          </Suspense>
        }
      />
      {/* Public APK download landing page. */}
      <Route
        path="/download/android"
        element={
          <Suspense fallback={<Loader />}>
            <AndroidDownload />
          </Suspense>
        }
      />
      {/* Print-friendly device setup sheet (admin-only via cookie). */}
      <Route
        path="/devices/:id/print-sheet"
        element={
          <Suspense fallback={<Loader />}>
            <PrintSheet />
          </Suspense>
        }
      />
      {/* Player URL shortener — same component, different path. */}
      <Route
        path="/p/:deviceCode"
        element={
          <Suspense fallback={<Loader />}>
            <Player />
          </Suspense>
        }
      />
      <Route
        path="/devices/:id/monitoring"
        element={
          <Suspense fallback={<Loader />}>
            <DeviceDetailMonitoring />
          </Suspense>
        }
      />

      {/* Signage Users + Activity */}
      <Route
        path="/signage-users"
        element={
          <Suspense fallback={<Loader />}>
            <SignageUsersList />
          </Suspense>
        }
      />
      <Route
        path="/signage-activity"
        element={
          <Suspense fallback={<Loader />}>
            <SignageActivityList />
          </Suspense>
        }
      />

      <Route element={<Navigate replace to="/dashboard" />} path="*" />
    </Routes>
  );
};

export default AppRoutes;
